import React from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './CourseEnrolmentListItem.react';
import LinearProgress from 'material-ui/LinearProgress';
import FlatButton from 'material-ui/FlatButton';

import IconPerson from 'material-ui/svg-icons/action/perm-identity';
import UpIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import DownIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import UserStore from '../../stores/UserStore';
import UserActions from '../../actions/UserActionCreator';

import CourseActions from '../../actions/CourseActionCreator';
import CourseEnrolmentStore from '../../stores/CourseEnrolmentStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { formatName } from '../../utils/StringUtils';

const CourseEnrolmentListByUser = React.createClass({

    getInitialState: function() {
        return {
            details: {
                id: '',
                title: '',
                firstName: '',
                lastName: '',
                initials: '',
                dateOfBirth: '',
                jobRole: '',
                username: '',
                email: '',
                visits: '',
                lastLogin : '',
            },
            enrolments: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/user/' + this.props.routeParams.userId,
                    icon: <IconPerson />,
                    label: 'User profile',
                },
            ],
            links: {
                back: '/dashboard/courses',
                edit: '',
            },
            sort: 'name',
            page: 0,
            limit: 50,
            isLoading:  true,
            fetchedAll: false,
            showButton: false
        }
    },

    componentWillMount: function(){
        UserStore.addChangeListener(this.onChange);
        UserActions.getById(this.props.routeParams.userId);

        CourseEnrolmentStore.addChangeListener(this.onChange);
        CourseActions.getEnrolmentsByUserId(this.props.routeParams.userId, { limit: this.state.limit });
        CourseActions.getEnrolmentProgressByUser(this.props.routeParams.userId);

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});
        window.addEventListener('scroll', this.handleScroll);
    },

    componentWillUnmount: function() {
        UserStore.removeChangeListener(this.onChange);
        CourseEnrolmentStore.removeChangeListener(this.onChange);
        window.removeEventListener('scroll', this.handleScroll);
    },

    render: function() {
        return (
            <div ref="userCourses" >
                <ListView
                    title={formatName(this.state.details)}
                    items={this.state.enrolments}
                    itemDecorator={ListItem}
                    actions={this.state.actions}
                />
                {this.state.isLoading && (
                    <LinearProgress mode="indeterminate" />
                )}
                {this.state.showButton && (
                    <FlatButton
                        label={this.state.fetchedAll ? 'Back to top' : 'Load more'}
                        icon={this.state.fetchedAll ? <UpIcon/> : <DownIcon/>}
                        onTouchTap={this.state.fetchedAll ? () => window.scrollTo(0, 0) : this.loadNextPage}
                        disabled={this.state.isLoading}
                        fullWidth
                    />
                )}
            </div>
        );
    },

    onChange: function() {
        const details = UserStore.getById(this.props.routeParams.userId);
        if (details !== undefined) {
            this.setState({details});
        }

        const enrolments = CourseEnrolmentStore.getByUser(this.props.routeParams.userId);
        if (enrolments !== undefined) {
            this.setState({enrolments, isLoading: false});
        }
        if (CourseEnrolmentStore.fetchedAll()) {
            this.setState({fetchedAll: true});
        }
    },

    loadNextPage: function () {
        if (this.state.isLoading) { return; } //guard
        const page = this.state.page + 1;
        CourseActions.getEnrolmentsByUserId(this.props.routeParams.userId, {page, limit: this.state.limit });
        this.setState({page, isLoading: true});
    },

    handleScroll: function () {
        if (!this.state.showButton && window.scrollY) {
            this.setState({showButton: true});
        }
        if (!this.state.fetchedAll && (window.scrollY + window.innerHeight) === this.refs.userCourses.clientHeight) {
            this.loadNextPage();
        }
    }
});

CourseEnrolmentListByUser.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default CourseEnrolmentListByUser;
